/**
 * A spreadsheet cell as text, the way the Results → Upload tool reads it.
 * Shared so the browser's upload CSV and the server's Mass Renewal upload
 * CSV write every cell byte for byte the same.
 */

/** An Excel error cell (`#N/A`, `#REF!`), kept distinct from a blank. */
export interface SheetErrorCell {
  error: string;
}

export type SheetCell =
  string | number | boolean | SheetErrorCell | null | undefined;

export function isSheetErrorCell(cell: SheetCell): cell is SheetErrorCell {
  return typeof cell === "object" && cell !== null;
}

/**
 * A number as Excel shows it: integers as they are, anything else at 15
 * significant digits, so a stored `44.717400000000005` reads `44.7174`.
 */
function numberText(value: number): string {
  return Number.isInteger(value)
    ? String(value)
    : String(Number(value.toPrecision(15)));
}

/** A cell as trimmed text; an error cell as its code. Identifiers stay text: zeros are never dropped. */
export function sheetCellText(cell: SheetCell): string {
  if (cell === null || cell === undefined) return "";
  if (isSheetErrorCell(cell)) return cell.error;
  if (typeof cell === "number") return numberText(cell);
  return String(cell).trim();
}
